/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { object } from 'prop-types';
import { KeyboardArrowDown } from '@material-ui/icons';
import Collapse from '@material-ui/core/Collapse';
import { useUIDSeed } from 'react-uid';
import { useDispatch } from 'react-redux';

import MarkdownText from './MarkdownText';
import StyledButton from '../../../../../EnterpriseDesignSystem/Button/StyledButton';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const useStyles = makeStyles((theme) => ({
    dropdownContainer: (styles) => ({
        backgroundColor: styles?.backgroundColor || '#f5f5f5',
        borderRadius: '6px',
        padding: '16px',
    }),
    text: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        cursor: 'pointer',
        '& p': {
            fontWeight: 'bold',
        },
    },
    arrow: {
        transition: 'transform 0.3s ease',
    },
    arrowOpen: {
        transform: 'rotate(180deg)',
    },
    subHeading: {
        marginTop: theme.spacing(1),
    },
}));

const Dropdown = ({ item }) => {
    const classes = useStyles({
        backgroundColor: item?.background?.color,
    });

    const dispatch = useDispatch();
    const seed = useUIDSeed();
    const [open, setOpen] = useState(false);

    const toggleOpen = () => {
        setOpen((prev) => !prev);
    };

    const handleClick = (data) => {
        const {
            tracking_event_category,
            tracking_event_action,
            tracking_event_label,
        } = data?.button?.tracking || {};

        dispatch(trackEvent({
            eventCategory: tracking_event_category || '',
            eventAction: tracking_event_action || '',
            eventLabel: tracking_event_label || '',
        }));
    };

    const labels = item?.label || [];
    const mainLabel = labels[0];
    const subLabels = labels.slice(1);
    const ctaButton = item?.button || null;

    return (
        <div className={classes.dropdownContainer}>
            {mainLabel && (
                <div className={classes.text} onClick={toggleOpen} role="button" tabIndex={0} onKeyDown={toggleOpen}>
                    <MarkdownText data={mainLabel} />
                    <KeyboardArrowDown
                        className={`${classes.arrow} ${open ? classes.arrowOpen : ''}`}
                    />
                </div>
            )}

            <Collapse in={open} timeout="auto" unmountOnExit>
                <div className={classes.subHeading}>
                    {subLabels.map((label) => (
                        <MarkdownText key={seed(label)} data={label} />
                    ))}
                </div>
                <StyledButton
                    label={ctaButton?.button?.link?.title}
                    variant={ctaButton?.button?.variant}
                    size={ctaButton?.button?.size}
                    link={ctaButton?.button?.link?.href}
                    icon={ctaButton?.icon || {}}
                    handleOnClick={() => handleClick(ctaButton)}
                />
            </Collapse>
        </div>
    );
};

Dropdown.propTypes = {
    item: object,
};

Dropdown.defaultProps = {
    item: {},
};

export default Dropdown;
